<template>
  <div id="certify">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="./images/certify01.png" />
          <p>非常难得又值钱的认证证书</p>
        </div>
        <div class="swiper-slide">
          <img src="./images/certify02.png" />
          <p>深圳市优秀互联网企业认定证书</p>
        </div>
        <div class="swiper-slide">
          <img src="./images/certify03.png" />
          <p>质量管理体系认证荣誉证书</p>
        </div>
        <div class="swiper-slide">
          <img src="./images/certify04.png" />
          <p>计算机软件著作权登记证书</p>
        </div>
        <div class="swiper-slide">
          <img src="./images/certify05.png" />
          <p>增值电信业务经营许可证</p>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>

import Swiper, { Navigation, Pagination,Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination,Autoplay]);

export default {
  name: "Team",
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    initSwiper() {
      new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable :true,
        },
        on: {
          progress: function (progress) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              let slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              let translate = slideProgress * modify * 260 + "px";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function (swiper, transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      });
    },
  },
};
</script>


<style lang="less" scoped>
@import url("swiper/swiper-bundle.min.css");
@import "css/certify.css";
</style>